import PropTypes from 'prop-types';

export const LabelValueKeyPair = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string,
});

export const LabelValueKeyPairNumeric = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.number,
});

export const AirportRailStation = PropTypes.shape({
  code: PropTypes.string,
  name: PropTypes.string,
  isRail: PropTypes.bool,
});

export const AttendeePropType = PropTypes.shape({
  attendeeId: PropTypes.number,
  meetingId: PropTypes.number,
  nameNum: PropTypes.number,
  email: PropTypes.string,
  invitationStatus: LabelValueKeyPair,
  bookNum: PropTypes.string,
  policyId: PropTypes.number,
  attendeeType: LabelValueKeyPair,
});

export const Traveler = PropTypes.shape({
  canApprove: PropTypes.string,
  canBook: PropTypes.string,
  initials: PropTypes.string,
  name: PropTypes.string,
  nameNum: PropTypes.number,
  profileImageUrl: PropTypes.string,
});

export const Location = PropTypes.shape({
  code: PropTypes.string,
  name: PropTypes.string,
  rgn: PropTypes.string,
  isValid: PropTypes.bool,
  lat: PropTypes.number,
  lon: PropTypes.number,
  region: PropTypes.string,
  city: PropTypes.string,
  postalCode: PropTypes.string,
  country: PropTypes.string,
  street: PropTypes.string,
  locId: PropTypes.string,
  keyType: PropTypes.string,
  display: PropTypes.string,
  shortDisplay: PropTypes.string,
  stateCode: PropTypes.string,
  countryCode: PropTypes.string,
  cityCode: PropTypes.string,
  useCityForHotelSearch: PropTypes.bool,
  effectiveRank: PropTypes.number,
  anum: PropTypes.number,
  nameNum: PropTypes.number,
  airports: PropTypes.arrayOf(AirportRailStation),
});

export const Meeting = PropTypes.shape({
  meetingId: PropTypes.number,
  aNum: PropTypes.number,
  name: PropTypes.string,
  mediumType: LabelValueKeyPair,
  meetingType: LabelValueKeyPair,
  startDate: PropTypes.number,
  startTime: PropTypes.number,
  endDate: PropTypes.number,
  endTime: PropTypes.number,
  locationId: PropTypes.string,
  location: Location,
  lastUpdateByNameNum: PropTypes.number,
  tripApprovalsRequiredType: LabelValueKeyPair,
  lastCustomMessage: PropTypes.string,
  meetingStatus: LabelValueKeyPair,
  attendeesNotInvited: PropTypes.number,
  attendeesInProgress: PropTypes.number,
  attendeesCompleted: PropTypes.number,
  start: PropTypes.instanceOf(Date),
  startTimeFormatted: PropTypes.string,
  startDateFormatted: PropTypes.string,
  end: PropTypes.instanceOf(Date),
  endTimeFormatted: PropTypes.string,
  endDateFormatted: PropTypes.string,
  status: PropTypes.string,
});

export const airSettings = PropTypes.shape({
  meetingId: PropTypes.number,
  airCreditCardId: PropTypes.number,
  airDestinationLocation: Location,
  airDestinationLocationId: PropTypes.string,
  airline: PropTypes.string,
  airMaxCabinType: LabelValueKeyPair,
  airMaxPrice: PropTypes.number,
  airPaymentOptionsType: LabelValueKeyPair,
});

export const meetingAirports = PropTypes.arrayOf(
  PropTypes.shape({
    locationId: PropTypes.string,
    location: Location,
    arriveBefore: PropTypes.string,
    departAfter: PropTypes.string,
  }),
);

export const hotelSettings = PropTypes.shape({
  meetingId: PropTypes.number,
  hotelAllowEarlyArrivalDays: PropTypes.number,
  hotelAllowLateDepartureDays: PropTypes.number,
  hotelCreditCardId: PropTypes.number,
  hotelLeisureRatesType: LabelValueKeyPair,
  hotelMaxNightlyRate: PropTypes.number,
  hotelMaxStarRating: LabelValueKeyPairNumeric,
  hotelPaymentOptionsType: LabelValueKeyPair,
  hotelRefundableOnly: PropTypes.bool,
  hotelRequireStayAtPropIds: PropTypes.bool,
});

export const MeetingFull = PropTypes.shape({
  meeting: Meeting,
  approvers: PropTypes.arrayOf(Traveler),
  airSettings,
  hotelSettings,
  carSettings: PropTypes.shape({
    meetingId: PropTypes.number,
    carAllowEarlyPickupDays: PropTypes.number,
    carAllowLateDropOffDays: PropTypes.number,
    carVendor: PropTypes.string,
    carMaxDailyRate: PropTypes.number,
    carMaxSize: LabelValueKeyPair,
    carPaymentOptionsType: LabelValueKeyPair,
  }),
  attendees: PropTypes.arrayOf(AttendeePropType),
  meetingRecommendedHotels: PropTypes.arrayOf(
    PropTypes.shape({
      propId: PropTypes.string,
      hotelName: PropTypes.string,
      metroRegion: PropTypes.string,
      soldOut: PropTypes.bool,
      rateStatus: PropTypes.string,
      averageNightlyRate: PropTypes.number,
      strikethroughRate: PropTypes.number,
      isPreferred: PropTypes.bool,
      chainCode: PropTypes.string,
      allianceCode: PropTypes.string,
      starRating: PropTypes.number,
      hotelLocation: PropTypes.string,
      hotelAddress: PropTypes.shape({
        address1: PropTypes.string,
        city: PropTypes.string,
        postalCode: PropTypes.string,
        id: PropTypes.number,
        addressee: PropTypes.string,
        street2: PropTypes.string,
        street3: PropTypes.string,
        state: PropTypes.string,
        country: PropTypes.string,
        countryName: PropTypes.string,
      }),
      hotelPhone: PropTypes.string,
      hotelFax: PropTypes.string,
      thumbNail: PropTypes.string,
      lat: PropTypes.number,
      lon: PropTypes.number,
      description: PropTypes.string,
      distance: PropTypes.number,
      defaultSortOrder: PropTypes.number,
      yearBuilt: PropTypes.string,
      yearRenovated: PropTypes.string,
      numFloors: PropTypes.number,
      numRooms: PropTypes.number,
      travelerBookings: PropTypes.number,
      colleagueNames: PropTypes.string,
      colleaguesVisited: PropTypes.number,
      covidSafe: PropTypes.bool,
      policyViolationCodes: PropTypes.string,
      policyViolations: PropTypes.string,
      images: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
      amenities: PropTypes.string,
      rooms: PropTypes.string,
    }),
  ),
  meetingAirports,
  billingFields: PropTypes.arrayOf(
    PropTypes.shape({
      meetingId: PropTypes.number,
      billingFieldID: PropTypes.number,
      billingFieldName: PropTypes.string,
      billingFieldValue: PropTypes.string,
    }),
  ),
});
